import { render, staticRenderFns } from "./DetailSettlementExternal.vue?vue&type=template&id=1448a82f"
import script from "./DetailSettlementExternal.vue?vue&type=script&lang=js"
export * from "./DetailSettlementExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports